export let extraEntropy = false

/** @internal */
export function setExtraEntropy(entropy: boolean) {
  extraEntropy = entropy
}
